// Each entry is a filter name, or a [name, ...args] tuple for filters that take
// extra arguments, e.g. applyFilters(['stripHtml', ['truncate', 140]], text)
export const applyFilters = (filters, content) => {
  if (Array.isArray(filters)) {
    filters.forEach((filter) => {
      const [name, ...args] = Array.isArray(filter) ? filter : [filter];
      if (typeof filterList[name] === 'function') {
        content = filterList[name](content, ...args);
      }
    });
  } else if (typeof filters === 'string') {
  }

  return content;
};

const filterList = {
  correctUrl: (str) => {
    if (filterList.isString(str) && !str.match(/^(https?\:\/\/)/g)) {
      str = 'http://' + str;
    }

    return str;
  },
  isString: (str) => {
    return typeof str === 'string';
  },
  linkify: (str) => {
    if (filterList.isString(str)) {
      return str.replace(/(https?\:\/\/[^\s]+[^\s\.])(?=[\s\.]|$)/g, function (link) {
        return '<a href="' + filterList.correctUrl(link) + '" target="_blank">' + filterList.truncate(link, 20) + '</a>';
      });
    } else {
      return '';
    }
  },
  paragrapherize: (str) => {
    if (str == null) {
      return '';
    } else {
      return str.replace(/\n/, '<br /><br />');
    }
  },
  phone: (phoneStr) => {
    if (phoneStr == null || phoneStr == undefined) {
      return '';
    } else {
      var digits = phoneStr.replace(/\D/g, '');
      if (digits.length > 8) {
        return digits.replace(/\D/, '').replace(/^1?(\d{3})(\d{3})(\d{4})(\d+)?$/, function (all, group1, group2, group3, ext) {
          var mainPhone = group1 + '-' + group2 + '-' + group3;
          if (ext) {
            return mainPhone + ' ext. ' + ext;
          } else {
            return mainPhone;
          }
        });
      } else {
        return phoneStr;
      }
    }
  },
  truncate: (str, number) => {
    if (filterList.isString(str) && str.length - 3 > number) {
      return str.slice(0, number) + '...';
    } else {
      return str;
    }
  },
  // TODO: truncate link isn't catching some instances, e.g. https://www.emuhsd.org/site/default.aspx?PageType=3&ModuleInstanceID=1768&ViewID=5C8B25C6-C8F8-4BD5-923B-8A7C70A93DDA&RenderLoc=0&FlexDataID=2808&PageID=1385&Comments=true
  truncateLink: (link) => {
    var match = link.match(/^(https?:\/\/[a-zA-Z\d-.]+[a-zA-Z]*\/).*(\/.*)/);
    if (match) {
      return match[1] + '...' + match[2];
    } else {
      return link;
    }
  },
  urlEncode: (str) => {
    return encodeURIComponent(str);
  }
};
